// Stakeholder Summary Card Component
const StakeholderSummaryCard = ({ stakeholder, data, stakeholderNumber = 1 }) => {
  // Different gradients for different stakeholders
  const gradients = {
    1: "from-[#5303BB] to-[#160131]",
    2: "from-[#F27100] to-[#D85F00]",
  };

  const gradient = gradients[stakeholderNumber] || gradients[1];

  // Summary Section Component
const SummarySection = ({ title, items, emptyText, renderType }) => {
  return (
    <div>
      <h4 className="text-xs font-bold text-gray-900 uppercase tracking-wide mb-3 text-center">
        {title}
      </h4>
      {items.length > 0 ? (
        renderType === "badges" ? (
          <div className="flex flex-wrap justify-center gap-2">
            {items.map((item, index) => (
              <span
                key={index}
                className="px-3 py-1.5 bg-black text-white text-xs rounded-full font-medium"
              >
                {item}
              </span>
            ))}
          </div>
        ) : (
          <ul className="space-y-2">
            {items.map((item, index) => (
              <li
                key={index}
                className="flex items-start gap-2 text-sm text-gray-700"
              >
                <span className="text-gray-400 mt-0.5">•</span>
                <span>{item}</span>
              </li>
            ))}
          </ul>
        )
      ) : (
        <p className="text-gray-400 text-sm italic text-center">{emptyText}</p>
      )}
    </div>
  );
};

  return (
    <div className="bg-white rounded-2xl shadow-lg overflow-hidden border border-gray-200 relative w-[429px]">
      {/* Header */}
      <div 
        className={`bg-gradient-to-r ${gradient} py-4 px-6 text-white text-center relative`} 
        style={{ height: "146px" }}
      >
        <p className="text-sm font-semibold uppercase tracking-wide mb-3">
          STAKEHOLDER #{String(stakeholderNumber).padStart(2, "0")}
        </p>
        <div className="absolute left-1/2 transform -translate-x-1/2 top-[70px] 2xl:top-12 w-[130px] h-[130px] 2xl:w-[163.977294921875px] 2xl:h-[163.977294921875px] rounded-full bg-[#F1F1F1] border-[2.76px] border-[#E8E8E8] shadow-xl flex items-center justify-center text-8xl">
          {stakeholder?.avatar ? (
            stakeholder.avatar.startsWith("http") ||
            stakeholder.avatar.startsWith("/static") ||
            stakeholder.avatar.startsWith("/media") ? (
              <img
                src={stakeholder.avatar}
                alt={stakeholder.name}
                className="2xl:w-32 2xl:h-32 w-28 h-28 object-contain rounded-full"
              />
            ) : (
              <span className="text-7xl">{stakeholder.avatar}</span>
            )
          ) : (
            "🦁"
          )}
        </div>
      </div>

      {/* Body */}
      <div className="pt-20 pb-8 px-8 space-y-6">
        {/* Name and Role */}
        <div className="text-center pb-6 border-b border-gray-200">
          <h3 className="text-2xl font-bold text-gray-900 mb-2">
            {stakeholder?.name || ""}
          </h3>
          <p className="text-sm text-gray-600 uppercase tracking-wide">
            {stakeholder?.role || ""}
          </p>
        </div>

        {/* Their Core Values */}
        <SummarySection
          title="Their Core Values"
          items={data?.values || []}
          emptyText="No values recorded"
          renderType="badges"
        />

        {/* Things That Get Them Promoted */}
        <SummarySection
          title="Things That Get Them Promoted"
          items={data?.kpis || []}
          emptyText="No KPIs recorded"
          renderType="list"
        />

        {/* Likes & Interests */}
        <SummarySection
          title="Likes & Interests"
          items={data?.interests || []}
          emptyText="No interests recorded"
          renderType="list"
        />
      </div>
    </div>
  );
};

export default StakeholderSummaryCard;